import $ from 'jquery'

export default () => {
  $(() => {
    if (!$('body.page-template-introduction').length) return

    let $sectionChapters = $('.section-chapters')
    if ($sectionChapters.length) {
      $sectionChapters.find('.chapter__briefs .chapter__brief .chapter-click').on('click', function(e) {
        if ($(e.target).parent().hasClass('active')) return

        $(e.target).closest('.chapter__briefs').children('.chapter__brief').removeClass('active')
        $(e.target).closest('.chapter__brief').addClass('active')
        $('html, body').animate({
          scrollTop: $("#" + $(e.target).data('target')).offset().top - 100   // header height mobile
        }, 500)
      })
      $sectionChapters.find('.chapter__headlines .chapter-click').on('click', function(e) {
        if (!$(e.target).hasClass('active')) {
          $(e.target).parent().children('.chapter-click').removeClass('active')
          $(e.target).addClass('active')
          if ($(window).width() < 992) {
            $('html, body').animate({
              scrollTop: $("#" + $(e.target).data('target')).offset().top - 128   // header height lg
            }, 500)
          } else {
            $('html, body').animate({
              scrollTop: $("#" + $(e.target).data('target')).offset().top - 190   // header height xl
            }, 500)
          }
        }
      })
    }
  })
}
